function formatBirthday(date) {
  if (!date) { return "" }

  var monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  var bdayDay = date.getDate();
  var bdayYear = date.getFullYear();
  var bdayMonth = monthNames[date.getMonth()];

  return bdayMonth + ' ' + bdayDay + ', ' + bdayYear;
}

function searchResultItem(patient) {
  var href = '/patients/' + patient.id;
  var middle_name = patient.middle_name || "";
  var name = patient.last_name + ', ' + patient.first_name + ' ' + middle_name;
  var birthday = patient.birthday && patient.birthday.length > 0 ? new Date(patient.birthday) : false;
  var avatar_url = patient.avatar_image_url;
  var bday = formatBirthday(birthday);

  var resultItem = document.createElement('li');
  resultItem.classList.add('search-result--item');

  var patientLink = document.createElement('a');
  var patientLinkContent = document.createTextNode(name);
  patientLink.classList.add('search-result--name');
  patientLink.href = href;
  patientLink.appendChild(patientLinkContent);


  if (bday.length > 0) {
    var birthdayEl = document.createElement('span');
    var birthdayElContent = document.createTextNode(bday);
    birthdayEl.appendChild(birthdayElContent);
    birthdayEl.classList.add('search-result--bday');
    patientLink.appendChild(birthdayEl);
  }

  var avatarEl = document.createElement('img');
  avatarEl.classList.add('img-circle');
  avatarEl.src = avatar_url;

  resultItem.appendChild(avatarEl);
  resultItem.appendChild(patientLink);

  return resultItem;
}

function initialState() {
  return "<p class='p-4'>Try searching for a patient</p>";
}

function noPatientsFound(search_type, search_value) {
  var label = ($("select#patient_search_type option:selected").text() || "Search Value").trim();
  var message = 
    "<div class='flex flex-col items-center justify-center py-12 text-center bg-gray-50 rounded-lg border border-dashed border-gray-300 mt-4'>" +
      "<i class='fa fa-user-times text-gray-400 text-5xl mb-4'></i>" +
      "<h3 class='text-lg font-medium text-gray-900'>No patients found</h3>" +
      "<p class='text-sm text-gray-500 mt-1'>We couldn't find anyone matching <span class='font-semibold'>\"" + search_value + "\"</span> for " + label + ".</p>" +
      "<div class='mt-6'>" +
        "<a href='#' class='showCreateForm inline-flex items-center justify-center gap-2 rounded-md border border-transparent bg-meclinic-teal px-4 py-2 text-sm font-medium text-white hover:bg-meclinic-teal-dark focus:outline-none focus:ring-2 focus:ring-meclinic-teal no-underline'>" +
          "<i class='fa fa-user-plus'></i> Add New Patient Record" +
        "</a>" +
      "</div>" +
    "</div>";
  return message;
}

function addVisitorToQueueButton(id) {
  var href = '/visits/new?patient_id=' + id;
  var btn = "<a href='" + href + "' class='inline-flex items-center justify-center rounded-md border border-transparent bg-meclinic-teal px-2 py-1 text-xs font-medium text-white hover:bg-meclinic-teal-dark focus:outline-none focus:ring-2 focus:ring-meclinic-teal'>Create Visit</a>";
  return btn;
}

export function fuzzySearchPatient() {
  var search_type = $("select#patient_search_type").val() || "";
  var search_value = $("input#patient_search_value").val() || "";

  var patient_name = search_type === "patient_name" ? search_value : "";
  var birthday = search_type === "patient_birthdate" ? search_value : "";
  var custom_field_key = search_type.indexOf("custom_field:") === 0 ? search_type.replace("custom_field:", "") : "";
  var custom_field_value = custom_field_key ? search_value : "";

  var inputVals = search_value;

  var $patients = $("#fuzzy_patients");
  
  var url = "/patients/search.json?patient_name=" + encodeURIComponent(patient_name) +
            "&patient_birthdate=" + encodeURIComponent(birthday);
            
  if (custom_field_key) {
    url += "&custom_field_key=" + encodeURIComponent(custom_field_key) +
           "&custom_field_value=" + encodeURIComponent(custom_field_value);
  }

  $.ajax({
    cache: false,
    type: "GET",
    url: url,
    success: function(data, event, xhr) {
      $patients.empty();

      var patients = data.html;
      $patients.append( patients );

      var hasPatients = patients.length > 0;
      var hasInput = inputVals.trim().length > 0;

      if( !hasInput ) {
        $patients.html(initialState());
      } else if ( !hasPatients ) {
        var message = noPatientsFound(search_type, search_value);
        $patients.html(message);
        setModalButtons();
      }
    },
    error: function(data, event, xhr) {
      console.log("Patient not found");
    }
  });
}

export function showCreateForm(event) {
  if (event && event.target && event.target.blur) {
    event.target.blur();
  }
  var $createPatientModal = $(".create_patient");

  if ($createPatientModal.length && window.ModalManager && typeof window.ModalManager.open === "function") {
    window.ModalManager.open($createPatientModal.get(0));
  }

  setTimeout(function() {
    var firstField = $createPatientModal.find('input[type="text"], input[type="search"], input[type="email"], input[type="tel"], input:not([type]), textarea, select').filter(':visible').first().get(0);
    if (firstField) {
      firstField.focus();
      if (firstField.select) { firstField.select(); }
    }
  }, 800);
  setTimeout(function() {
    var firstField = $createPatientModal.find('input#visit_patient_attributes_last_name').get(0) || $createPatientModal.find('input[type="text"], input[type="search"], input[type="email"], input[type="tel"], input:not([type]), textarea, select').filter(':visible').first().get(0);
    if (firstField) {
      firstField.focus();
      if (firstField.select) { firstField.select(); }
    }
  }, 1600);

  var $first_name = $("input#visit_patient_attributes_first_name");
  var $last_name = $("input#visit_patient_attributes_last_name");
  var $middle_name = $("input#visit_patient_attributes_middle_name");
  var $birthday = $("input#fuzzy_patient_birthday");

  var search_type = $("select#patient_search_type").val();
  var search_value = $("input#patient_search_value").val() || "";

  if (search_type === "patient_name") {
    $last_name.val(search_value);
  } else if (search_type === "patient_birthdate") {
    $birthday.val(search_value);
  } else if (search_type && search_type.indexOf("custom_field:") === 0) {
    var key = search_type.replace("custom_field:", "");
    var customFieldInput = $createPatientModal.find("input[name*='[custom_values][" + key + "]']");
    if (customFieldInput.length) {
      customFieldInput.val(search_value);
    }
  }
}

function setModalButtons() {
  $('a.showCreateForm').click(function(event){
    showCreateForm(event);
  });
}

function getDefaultAvatarSrc() {
  var $preview = $('.js-temp-avatar');
  if (!$preview.length) { return ''; }

  return $preview.data('default-src') || $preview.attr('src') || '';
}

function resetAvatarPreview() {
  var defaultSrc = getDefaultAvatarSrc();
  if (!defaultSrc) { return; }

  $('.js-temp-avatar').attr('src', defaultSrc);
  $("#avatar_url").val('');
  $("#avatar_type").val('');
}

var visitCameraHooks = {
  onComplete: function(response) {
    try {
      var obj = JSON.parse(response);
      if (obj.status === "Success") {
        $("#camera_input_url").val(obj.url);
        set_avatar_preview();
      }
    } catch (error) {
      console.log(error);
    }
  }
}

function set_avatar_preview() {
  var active = $(".js-avatar-options input:radio:checked");
  var img_url = "";
  var source_type = "";

  if (!active.length) {
    resetAvatarPreview();
    return;
  }

  if (active.val() == "file") {
    img_url = $("#file_input_url").val();
    source_type = "file";
  } else {
    img_url = $("#camera_input_url").val();
    source_type = "url";
  }

  if (img_url != "") {
    $('.js-temp-avatar').attr('src', img_url);
    $("#avatar_url").val(img_url);
    $("#avatar_type").val(source_type);
    return;
  }

  resetAvatarPreview();

}

window.set_avatar_preview = set_avatar_preview;

// http://stackoverflow.com/questions/4459379/preview-an-image-before-it-is-uploaded
function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      $("#file_input_url").val(e.target.result);
      set_avatar_preview();
    }
    reader.readAsDataURL(input.files[0]);
  }
}

function toggleSecretWord (eye_btn) {
  var eye_btn = $(eye_btn);
  var wrap = eye_btn.closest(".js-password-wrap");
  var node = wrap.find('.js--secretWord');
  var eye_con = wrap.find('.js--eyeCon');
  var attr = node.attr("type") === 'password' ? 'text' : 'password';
  node.attr('type', attr);
  eye_con.toggleClass('fa-eye-slash');
  eye_con.toggleClass('fa-eye');
  var isVisible = attr === 'text';
  eye_btn.attr('aria-pressed', isVisible);
  eye_btn.attr('aria-label', isVisible ? 'Hide password' : 'Show password');
  eye_btn.attr('title', isVisible ? 'Hide password' : 'Show password');
  eye_btn.toggleClass('active');
  eye_btn.blur();
}

function setLoginFieldError($field, $errorNode, message) {
  $errorNode.text(message);
  $errorNode.toggleClass('hidden', !message);
  $field.toggleClass('border-red-600', !!message);
}

function validateLoginEmail() {
  var $email = $('.js-login-email');
  var $error = $('#login-email-error');
  if (!$email.length || !$error.length) { return true; }

  var value = ($email.val() || '').trim();
  if (!value) {
    setLoginFieldError($email, $error, 'Email is required.');
    return false;
  }

  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(value)) {
    setLoginFieldError($email, $error, 'Enter a valid email address.');
    return false;
  }

  setLoginFieldError($email, $error, '');
  return true;
}

function validateLoginPassword() {
  var $password = $('.js-login-password');
  var $error = $('#login-password-error');
  if (!$password.length || !$error.length) { return true; }

  var value = $password.val() || '';
  if (!value) {
    setLoginFieldError($password, $error, 'Password is required.');
    return false;
  }

  setLoginFieldError($password, $error, '');
  return true;
}

function toggleCapsLockWarning(e) {
  var $warning = $('#caps-lock-warning');
  if (!$warning.length) { return; }
  var hasCapsLock = e.getModifierState && e.getModifierState('CapsLock');
  $warning.text(hasCapsLock ? 'Caps Lock is on.' : '');
  $warning.toggleClass('hidden', !hasCapsLock);
}

function resetLoginSubmitButton($form) {
  var $submit = $form.find('.js-login-submit');
  if (!$submit.length) { return; }

  $submit.prop('disabled', false).removeAttr('disabled');
  $submit.removeClass('disabled');

  var defaultLabel = $submit.data('default-label');
  if (defaultLabel) {
    if ($submit.is('input')) {
      $submit.val(defaultLabel);
    } else {
      $submit.text(defaultLabel);
    }
  }
}

$(function () {
  $(document).on('change', '#avatar_upload', function() {
    readURL(this);
  });

  $(".js-eye-button").click( function(e) {
    e.preventDefault();
    toggleSecretWord(this);
  });

  var $loginForm = $('.js-login-form');
  if ($loginForm.length > 0) {
    $('.js-login-email').on('blur input', validateLoginEmail);
    $('.js-login-email').on('blur input', resetLoginSubmitButton($loginForm));
    $('.js-login-password').on('blur input', validateLoginPassword);
    $('.js-login-password').on('keyup', toggleCapsLockWarning);
    $('.js-login-password').on('blur', function() {
      $('#caps-lock-warning').text('').addClass('hidden');
      resetLoginSubmitButton($loginForm);
    });

    $loginForm.on('submit', function(e) {
      var isEmailValid = validateLoginEmail();
      var isPasswordValid = validateLoginPassword();
      if (!isEmailValid || !isPasswordValid) {
        e.preventDefault();
        resetLoginSubmitButton($loginForm);
      }
    });
  }

  $(".patient--other-details-title a")
    .mouseover(function(e) {
      $('.otherDetails').collapse('show');
    })
    .mouseout(function(e) {
      $('.otherDetails').collapse('hide');
    });

  $("#patient_search_type").on("change", function() {
    var dataType = $(this).find("option:selected").attr("data-type");
    var $input = $("#patient_search_value");

    $input.val("");

    if (dataType === "date") {
      $input.addClass("datepicker");
      if (window.initDatepickers) {
        window.initDatepickers($);
      } else if (typeof console !== 'undefined' && console.error) {
        console.error('window.initDatepickers is not defined; search datepicker will not initialize. Ensure legacy.js is loaded.');
      }
    } else {
      if ($input.data('xdsoft_datetimepicker')) {
        $input.datetimepicker('destroy');
      }
      $input.removeClass("datepicker");
    }

    if (typeof fuzzySearchPatient === "function" || window.fuzzySearchPatient) {
      window.fuzzySearchPatient ? window.fuzzySearchPatient() : fuzzySearchPatient();
    }
  });

  setModalButtons();

  var $display_patient_form =$(".display_patient_form");
  if ( $display_patient_form.length > 0 ) {
    $display_patient_form.on('click', function(){
      $(".js-patient-info").css("display", "none");
      $(".js-patient-info-form").css("display", "block");
    })
  }
});

function dynamic_add_fields(event, content, temp_id, target) {
    event.preventDefault();

    var new_id = new Date().getTime();
    var regexp = new RegExp(temp_id, "g");

    $(target).append(content.replace(regexp, new_id));
  }

$(document).on('change', '.js-general-survey-radio', function() {
  var $container = $(this).closest('form').find('.js-altered-sensorium-text-container');
  var $input = $container.find('.js-altered-sensorium-input');
  
  if ($(this).val() === 'Altered Sensorium') {
    $container.removeClass('hidden');
    $input.attr('required', true);
  } else {
    $container.addClass('hidden');
    $input.removeAttr('required');
    $input.val('');
  }
});

$(document).on('input', '#vital_weight_kg, #vital_height_cm', function() {
  var weight = parseFloat($('#vital_weight_kg').val()) || 0.0;
  var height = parseFloat($('#vital_height_cm').val()) || 0.0;
  var bmiResult = 0.0;
  var bmiClassification = "Invalid";

  if (height > 0) {
    var heightM = height / 100.0;
    bmiResult = (weight / Math.pow(heightM, 2)).toFixed(2);
    var bmiNum = parseFloat(bmiResult);
    if (bmiNum < 16.0 && bmiNum > 0) bmiClassification = "Severely Underweight";
    else if (bmiNum >= 16.0 && bmiNum < 18.5) bmiClassification = "Underweight";
    else if (bmiNum >= 18.5 && bmiNum < 25.0) bmiClassification = "Normal";
    else if (bmiNum >= 25.0 && bmiNum < 30.0) bmiClassification = "Overweight";
    else if (bmiNum >= 30.0) bmiClassification = "Obese";
  }

  if (bmiResult > 0) {
    $('.js-bmi-display').text(bmiResult + " (" + bmiClassification + ")");
    $('.js-bmi-container').removeClass('hidden');
  } else {
    $('.js-bmi-display').text("--");
  }
});